import { Tooltip } from 'primereact/tooltip';
import React from 'react';
interface HeaderAttendanceDatamodel {
  headerVisibility: boolean;
  text: string;
  toolTip: string;
}
export const HeaderAttendance: React.FC<HeaderAttendanceDatamodel> = ({
  headerVisibility,
  text,
  toolTip,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <label
        style={{
          alignItems: 'center',
          paddingBottom: '8px',
          textAlign: 'center',
          visibility: headerVisibility ? 'initial' : 'hidden',
        }}
      >
        נוכחות
      </label>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <label>{text}</label>
        <Tooltip target=".info-icon" />
        <i
          style={{ marginRight: '4px' }}
          className="pi pi-exclamation-circle info-icon"
          data-pr-tooltip={toolTip}
        />
      </div>
    </div>
  );
};
